import { makeItemsNav } from '@helpers/helper.rendering'
import { Link, navigate } from 'gatsby'
import React, { useState, useEffect } from 'react'
import { Accordion, Container, Nav } from 'react-bootstrap'
import { CSSVars, FiltersProperties, RealEstateDataHeaderData, StatePropertiesSlice } from 'types'
import { useLocation } from '@reach/router'
import '@boilerplates/header/1/index.scss'
import './index.scss'
import { useDispatch, useSelector } from 'react-redux'
import { getfavorites } from '@helpers/helper.favorites'
import toast, { Toaster } from 'react-hot-toast'
import $ from 'jquery'
import { useGetSummarySiteQuery } from '@apis/mediacore/core'
import Image from '@components/Image'
import ClientOnly from '@helpers/helper.client-only'
import { makeFormDataV2ByFilters, makeParamsGetByFilters } from '@helpers/helper.filters'
// import { mediacoreApi } from '@redux/apis/mediacoreApi'
import { AppDispatch } from '@redux/store' // ajustá el path
import { ownerExtended } from '@apis/mediacore/owner'

const isBrowser = typeof window !== 'undefined'

const Header13 = (
  props: RealEstateDataHeaderData & {
    development_id: string
    property_id: string
    novelty_id: string
    disableScrollHide?: boolean
  },
) => {
  const {
    pages,
    global_data,
    hiddenLogo,
    leftSide,
    buttonCompare,
    divisions,
    isInverted,
    background_secondary,
    textUppercase,
    is_short,
    sticky,
    bigContent,
    logoSize,
    fontColor,
    hoverColor,
    backgroundColor,
    image_gatsby,
    image, //Logo SVG
    spanText,
    disableScrollHide = false,
    height,
    hiddenMenu,
    items,
  } = props
  const { divisionPath, id: siteId } = global_data
  const { pathname: routerPathname, search: routerSearch } = useLocation()

  // Los helpers de filtros reescriben la URL con history.pushState/replaceState
  // (helper.filters.ts / helper.filters.v2.ts) y el router no se entera, así que
  // useLocation() puede quedar desactualizado (ej: queda ?tipo=1 aunque la barra
  // de direcciones ya muestre /venta). La fuente de verdad es window.location;
  // como pushState/replaceState no emiten eventos, se sincroniza por intervalo.
  const [browserUrl, setBrowserUrl] = useState<{ pathname: string; search: string } | null>(null)
  useEffect(() => {
    if (!isBrowser) return
    const sync = () => {
      setBrowserUrl((prev) =>
        prev?.pathname === window.location.pathname && prev?.search === window.location.search
          ? prev
          : { pathname: window.location.pathname, search: window.location.search },
      )
    }
    sync()
    window.addEventListener('popstate', sync)
    const interval = setInterval(sync, 500)
    return () => {
      window.removeEventListener('popstate', sync)
      clearInterval(interval)
    }
  }, [routerPathname, routerSearch])

  const pathname = browserUrl?.pathname ?? routerPathname
  const search = browserUrl?.search ?? routerSearch

  useEffect(() => {
    if (!height || !isBrowser) return
    const mql = window.matchMedia('(max-width: 992px)')

    const applyHeight = ({ matches }: MediaQueryListEvent | MediaQueryList) => {
      const h = matches ? height.mobile : height.desktop
      if (!h) return

      logoRef.current?.style.setProperty('height', h, 'important')
      rowRef.current?.style.setProperty('height', h, 'important')
    }

    applyHeight(mql)
    mql.addEventListener('change', applyHeight)
    return () => mql.removeEventListener('change', applyHeight)
  }, [height?.desktop, height?.mobile])

  const [listFavorites, setListFavorites] = useState(getfavorites('prop', 'template-site'))

  const { updaterFavorites } = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties,
  )!
  const countFavorites = listFavorites.length

  const [open, setOpen] = useState(false)

  const staticBody = () => {
    var body = document.getElementsByTagName('html')[0]
    body.classList.toggle('overflow-hidden')
  }

  useEffect(() => {
    const body = document.querySelector('body') as HTMLElement
    body.style.paddingTop = '0px'
  }, [pathname])

  useEffect(() => {
    setListFavorites(getfavorites('prop', 'template-site'))
  }, [updaterFavorites])

  const SupraNavBar = require(`@components/supraNavBar/1`)?.default

  const [scrollPercentage, setScrollPercentage] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      const scrollHeight = $(document).height()!
      const clientHeight = $('body').height()!
      const scrollTop = $('body').scrollTop()!
      const percentage = (scrollTop / (scrollHeight - clientHeight)) * 100
      setScrollPercentage(percentage)
    }

    $('body').on('scroll', handleScroll)

    return () => {
      $('body').off('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    if (hoverColor) {
      document.documentElement.style.setProperty('--hoverColor', hoverColor)
    }
  }, [hoverColor])

  useEffect(() => {
    if (fontColor) {
      document.documentElement.style.setProperty('--dashedColor', fontColor)
    }
  }, [fontColor])

  const logoRef = React.useRef<any>(null)
  const rowRef = React.useRef<HTMLDivElement>(null)

  const isCompiler = process.env.GATSBY_IS_SITE_COMPILER === 'true'

  const currentPage = pages?.find(
    (page) =>
      (pathname.replaceAll('/', '') === page.path.replaceAll('/', '') && !isCompiler) ||
      (isCompiler &&
        pathname !== '/' &&
        pathname.replace(global_data.divisionPath!, '').replaceAll('/', '') ===
          page.path.replaceAll('/', '')) ||
      (pathname.includes('/emprendimiento/') && page.path === '/desarrollo_detalle') ||
      (pathname.includes('/propiedad/') && page.path === '/propiedad_detalle') ||
      (pathname.includes('/novedad/') && page.path === '/novedad_detalle'),
  )

  const [isHover, setIsHover] = useState(false)

  const handleMouseEnter = () => {
    setIsHover(true)
  }
  const handleMouseLeave = () => {
    setIsHover(false)
  }

  const { data: allSiteData } = useGetSummarySiteQuery(
    process.env.GATSBY_IS_SITE_COMPILER == 'true' ? siteId : process.env.GATSBY_TENANTID,
  )

  const colSizeMobile = 5
  const justifyContentMobile =
    hiddenMenu && !buttonCompare?.value && !hiddenLogo
      ? 'justify-content-center'
      : buttonCompare?.value && !hiddenLogo
        ? 'justify-content-start'
        : 'justify-content-start'

  const typedStyles: CSSVars = {
    background: spanText,
    '--border-13': backgroundColor || 'transparent',
    '--height-mobile-13': height?.mobile || '100px',
    '--height-desktop-logo-13': logoSize
      ? (logoRef?.current?.clientHeight * parseInt(logoSize!.toString())) / 100 + 'px'
      : (logoRef?.current?.clientHeight * 55) / 100 + 'px',
  }

  // const dispatch = useDispatch()
  const dispatch = useDispatch<AppDispatch>()

  const handleNavHover = (operation: 'venta' | 'alquiler' | 'temporario') => {
    if (process.env.GATSBY_USE_MIDDLEWARE_V2?.toLowerCase() !== 'true') return

    const defaultOrders = { order: 'desc', order_by: 'id' }
    const perPage = Number(global_data?.pageConfig?.resultsPerPage) || 50
    const params_get = makeParamsGetByFilters(defaultOrders, 0, [], perPage)
    const params_post = makeFormDataV2ByFilters(
      { operation, specials: [] } as unknown as FiltersProperties,
      [],
      [],
      defaultOrders,
    )
    dispatch(
      ownerExtended.util.prefetch(
        'getNewProperties',
        {
          API_KEY: '',
          params_get: params_get || '',
          params_post: params_post || '',
          coordinates: [],
          polygonCoordinates: [],
          CTAG: [],
          W_CTAG: [],
        },
        { force: false },
      ),
    )
    // dispatch(
    //   mediacoreApi.util.prefetch(
    //     'getNewProperties',
    //     {
    //       API_KEY: '',
    //       params_get: params_get || '',
    //       params_post: params_post || '',
    //       coordinates: [],
    //       polygonCoordinates: [],
    //       CTAG: [],
    //       W_CTAG: [],
    //     },
    //     { force: false },
    //   ),
    // )
  }

  return (
    <header
      id="header"
      ref={logoRef}
      style={typedStyles}
      className={`blur b header13 header-2 ${is_short ? 'small-height' : ''} ${
        open ? 'opened' : 'closed'
      } ${hiddenLogo && ' hidden-logo '} ${background_secondary && 'background-secondary'}${process.env.GATSBY_IS_SITE_COMPILER === 'true' ? ' is_multisite' : ' '} ${
        sticky ? ' position-sticky ' : ''
      } ${
        !disableScrollHide &&
        parseInt(scrollPercentage.toFixed(2)) > 85 &&
        !currentPage?.hidden_footer
          ? // ? ' opacity'
            ''
          : ''
      }
  ${bigContent ? ' is-extended' : ''}`}
    >
      <ClientOnly>
        <Toaster
          toastOptions={{
            className: 'toast-className',
            style: { zIndex: 99999, maxWidth: 'fit-content' },
          }}
        />
      </ClientOnly>

      <Nav
        className="brand"
        style={{ background: spanText }}
        ref={logoRef}
      >
        {process.env.GATSBY_IS_SITE_COMPILER === 'true' && (
          <div className="divisions-nav d-flex align-items-center">
            <Container
              className="d-flex align-items-center justify-lg-content-between"
              fluid
            >
              <div
                onClick={() => navigate('/')}
                className={'px-0 ' + (isInverted ? 'd-lg-block' : 'd-lg-none')}
                style={{ opacity: 1 }}
              >
                {image_gatsby ? (
                  <Image
                    className="logo-header"
                    alt="main-logo"
                    objectFit={'cover'}
                    objectPosition={'center'}
                    image={image_gatsby!}
                    style={{
                      maxHeight: logoSize
                        ? (logoRef?.current?.clientHeight * parseInt(logoSize!.toString())) / 100 +
                          'px'
                        : (logoRef?.current?.clientHeight * 55) / 100 + 'px',
                      height: logoSize
                        ? (logoRef?.current?.clientHeight * parseInt(logoSize!.toString())) / 100 +
                          'px'
                        : (logoRef?.current?.clientHeight * 55) / 100 + 'px',
                    }}
                  />
                ) : (
                  <img
                    src={image}
                    className="logo-header"
                    alt="main-logo"
                  />
                )}
              </div>

              <SupraNavBar
                divisions={divisions}
                divisionPath={divisionPath}
              />
            </Container>
          </div>
        )}

        <div className="container-fluid">
          <div
            className={`row ${
              leftSide ? 'justify-content-lg-start' : 'justify-content-lg-between'
            } align-items-center ${
              process.env.GATSBY_IS_SITE_COMPILER === 'true'
                ? 'justify-content-end'
                : 'justify-content-between'
            }`}
            ref={rowRef}
          >
            <div
              className={`col-${colSizeMobile} d-flex d-lg-none ${justifyContentMobile} ${leftSide ? 'order-2' : 'order-2'}`}
            >
              {!isInverted && (
                <div
                  onClick={() => navigate('/')}
                  aria-label="enlace-inicio"
                  className="logo d-flex align-items-center justify-content-start"
                >
                  {image_gatsby ? (
                    <Image
                      className="logo-header"
                      objectFit="contain"
                      objectPosition={'center'}
                      style={{
                        maxHeight: logoSize
                          ? (logoRef?.current?.clientHeight * parseInt('55')) / 100 + 'px'
                          : (logoRef?.current?.clientHeight * 55) / 100 + 'px',
                        height: logoSize
                          ? (logoRef?.current?.clientHeight * parseInt('55')) / 100 + 'px'
                          : (logoRef?.current?.clientHeight * 55) / 100 + 'px',
                      }}
                      image={image_gatsby!}
                      alt="main-logo-image"
                    />
                  ) : (
                    <img
                      src={image}
                      className="logo-header"
                      alt="main-logo"
                    />
                  )}
                </div>
              )}
            </div>
            <div
              className={`col-lg-2 d-none d-lg-flex justify-content-lg-start ${leftSide ? 'order-lg-2' : 'order-lg-1'}`}
            >
              {!isInverted && (
                <div
                  onClick={() => navigate('/')}
                  aria-label="enlace-inicio"
                  className="logo d-flex align-items-center"
                >
                  {image_gatsby ? (
                    <Image
                      className="logo-header"
                      objectFit="contain"
                      objectPosition={'center'}
                      style={{
                        maxHeight: logoSize
                          ? (logoRef?.current?.clientHeight * parseInt(logoSize!.toString())) /
                              100 +
                            'px'
                          : (logoRef?.current?.clientHeight * 55) / 100 + 'px',
                        height: logoSize
                          ? (logoRef?.current?.clientHeight * parseInt(logoSize!.toString())) /
                              100 +
                            'px'
                          : (logoRef?.current?.clientHeight * 55) / 100 + 'px',
                      }}
                      image={image_gatsby!}
                      alt="main-logo-image"
                    />
                  ) : (
                    <img
                      src={image}
                      alt="main-logo"
                      className="logo-header"
                    />
                  )}
                </div>
              )}
            </div>
            <div
              className={`col-2 col-lg-9 d-flex ${
                leftSide
                  ? 'order-3 order-lg-1 justify-content-lg-end justify-content-end'
                  : 'order-3 order-lg-2 justify-content-end text-end'
              }`}
            >
              <div
                className={`nav-menu d-none d-lg-flex  ${
                  leftSide ? 'justify-content-start' : 'justify-content-lg-end'
                }`}
              >
                {(() => {
                  type NavEntry = { type: 'page' | 'item'; title: string; path: string }

                  const navPages: NavEntry[] = makeItemsNav(
                    allSiteData?.propiedades,
                    allSiteData?.novedades,
                    pages,
                    allSiteData?.posiciones,
                    true,
                    true,
                  )
                    .filter((page) => !page.path.includes('detalle'))
                    .map((page) => ({ type: 'page' as const, title: page.title, path: page.path }))

                  const merged: NavEntry[] = [...navPages]
                  ;(items ?? []).forEach((item) => {
                    const position = parseInt(item.value ?? '999')
                    merged.splice(position, 0, {
                      type: 'item',
                      title: item.title ?? '',
                      path: '/venta?tipo=1',
                      // path: (item.address ?? '').replace(/\/\?/, '?'),
                    })
                  })

                  const currentPath = pathname.endsWith('/') ? pathname : pathname + '/'
                  const currentParams = new URLSearchParams(search)

                  // Una entrada con query (ej: Terrenos → /venta?tipo=1) matchea solo si la URL
                  // actual tiene exactamente esos parámetros, ni más ni menos. Si matchea, es
                  // la única activa y suprime a la página base (/venta); en cualquier otra
                  // variante de /venta queda activa "Venta".
                  const activeQueryEntry = merged.find((entry) => {
                    const [base, query] = entry.path.split('?')
                    if (!query) return false
                    const section = base.endsWith('/') ? base : base + '/'
                    if (!currentPath.includes(section)) return false
                    const entryParams = new URLSearchParams(query)
                    return (
                      Array.from(currentParams.keys()).length ===
                        Array.from(entryParams.keys()).length &&
                      Array.from(entryParams).every(
                        ([key, value]) => currentParams.get(key) === value,
                      )
                    )
                  })

                  return merged.map((entry, index) => {
                    // Path sin query string y con barra final para comparar secciones completas
                    // (evita que '/venta?tipo=1' nunca matchee y que '/alquiler' matchee '/alquiler-temporario')
                    const entryPath = entry.path.split('?')[0]
                    const entrySection = entryPath.endsWith('/') ? entryPath : entryPath + '/'
                    // Una entrada con query (Terrenos → /venta?tipo=1) SOLO puede activarse
                    // por el match exacto de activeQueryEntry, nunca por coincidencia de
                    // sección: su base /venta matchearía siempre que estés en /venta.
                    const hasQuery = entry.path.includes('?')
                    const isActive = activeQueryEntry
                      ? entry === activeQueryEntry
                      : !hasQuery &&
                        ((entryPath !== '/' && currentPath.includes(entrySection)) ||
                          (pathname.includes('novedad/') && entryPath.includes('novedades')) ||
                          (entryPath === '/' && pathname === '/') ||
                          (pathname.toLowerCase() === divisionPath?.toLowerCase() + '/' &&
                            entryPath === '/'))

                    return (
                    <Nav.Item key={index}>
                      <Link
                        onClick={() => {
                          setOpen(false)
                          if (entry.type === 'item') {
                            navigate(entry.path, { replace: false })
                          }
                          document
                            .getElementsByTagName('html')[0]
                            .classList.remove('overflow-hidden')
                        }}
                        className={
                          (!textUppercase ? 'text-uppercase ' : 'text-none ') +
                          'text-center ' +
                          (isActive ? 'active text-underline' : '')
                        }
                        style={{ color: fontColor }}
                        to={entry.path}
                        onMouseEnter={() => {
                          if (entry.type === 'page') {
                            if (entry.path.includes('venta')) handleNavHover('venta')
                            else if (entry.path.includes('alquiler-temporario'))
                              handleNavHover('temporario')
                            else if (entry.path.includes('alquiler')) handleNavHover('alquiler')
                          }
                        }}
                      >
                        {entry.title}
                      </Link>
                    </Nav.Item>
                    )
                  })
                })()}
              </div>

              {!hiddenMenu && (
                <button
                  className="d-block d-lg-none"
                  id="toggle-nav"
                  onClick={() => {
                    setOpen(!open)
                    staticBody()
                  }}
                >
                  <div className="d-flex align-items-center">
                    <div className="status_nav d-none d-lg-inline">Menú </div>
                    <div className="ms-4">
                      <i></i>
                      <i></i>
                      <i></i>
                    </div>
                  </div>
                </button>
              )}
            </div>
            <ClientOnly>
              <div className="col-2 col-lg-1 offset-lg-0 order-lg-3">
                {buttonCompare?.link &&
                  (countFavorites === 0 ? (
                    <div
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                      style={{
                        background: buttonCompare?.secondary ? buttonCompare?.backgroundColor : '',
                      }}
                      className={
                        'btn-compare cursor-pointer disabled-compare border d-lg-flex d-flex align-items-center justify-content-center ' +
                        (buttonCompare?.secondary ? '' : ' btn btn-white')
                      }
                      onClick={() => toast.error('No tienes propiedades favoritas seleccionadas.')}
                    >
                      <div
                        className="mx-2 favorites-count"
                        style={{ fontStyle: 'normal' }}
                      >
                        {countFavorites}
                      </div>
                      <i
                        className={
                          `icon-favoritos-heart favorites-icon` +
                          (countFavorites < 1 && ' disabled ')
                        }
                      ></i>
                    </div>
                  ) : (
                    <div onClick={() => navigate(buttonCompare?.link)}>
                      <div
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        style={{
                          backgroundColor: buttonCompare?.secondary
                            ? isHover
                              ? buttonCompare?.valueColor
                              : buttonCompare?.backgroundColor
                            : '',
                        }}
                        className={`btn-compare cursor-pointer d-lg-flex d-flex align-items-center justify-content-center ${buttonCompare?.secondary ? '' : ' btn btn-white'} ${buttonCompare?.border ? 'border' : ''}`}
                      >
                        <div
                          className="me-3 cursor-pointer favorites-count"
                          style={{
                            fontStyle: 'normal',
                            color: buttonCompare?.secondary
                              ? isHover
                                ? buttonCompare?.backgroundColor
                                : buttonCompare?.valueColor
                              : '',
                          }}
                        >
                          {countFavorites}
                        </div>
                        <i
                          style={{
                            color: buttonCompare?.secondary
                              ? isHover
                                ? buttonCompare?.backgroundColor
                                : buttonCompare?.valueColor
                              : '',
                          }}
                          className={`icon-favoritos-heart favorites-icon`}
                        ></i>
                      </div>
                    </div>
                  ))}
              </div>
            </ClientOnly>
          </div>
        </div>
      </Nav>
    </header>
  )
}

export default Header13
